export default __webpack_public_path__ + "static/media/arrow-left-gray.27042d43.svg";